import { LAB_REPORT } from "@/api_framework/api_config";
import { IGenerateVialBarcodeResponse } from "@/api_framework/api_modals/LabReport";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";
import { useCurlLogger } from "../../useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useGenerateVialBarcodeAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

      const barcode: string | null = await axios
        .get(LAB_REPORT?.GENERATE_VIAL_BARCODE?.baseURL ?? "", {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IGenerateVialBarcodeResponse>) => res.data?.barcode ?? null)
        .catch((e: AxiosError) => {
          captureError(e);
          sendCurl(e.config["curlCommand"]);
          return null;
        });
      return barcode;
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
      return null;
    }
  }, [configuration, captureError, sendCurl]);

  return { execute };
};
